/**
 * Fabpad marketplace strip — seamless infinite horizontal marquee.
 * Starts hidden, clones logos once images are ready, then fades in.
 * Does not observe the track (cloning would retrigger layout forever).
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-fabpad-marketplace]');
  if (!section) return;

  var viewport = section.querySelector('[data-marketplace-viewport]');
  var track = section.querySelector('[data-marketplace-track]');
  if (!viewport || !track) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var originals = [];
  var settingUp = false;
  var ready = false;
  var lastViewportWidth = 0;
  var refreshTimer = null;

  function originalsList() {
    return Array.prototype.filter.call(track.children, function (node) {
      return !node.hasAttribute('data-marketplace-clone');
    });
  }

  function clearClones() {
    track.querySelectorAll('[data-marketplace-clone]').forEach(function (node) {
      node.remove();
    });
  }

  function cloneLogos() {
    clearClones();
    originals.forEach(function (logo) {
      var clone = logo.cloneNode(true);
      clone.setAttribute('data-marketplace-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  function waitForImages(callback) {
    var pending = [];

    originals.forEach(function (logo) {
      logo.querySelectorAll('img').forEach(function (img) {
        if (!img.complete || img.naturalWidth === 0) {
          pending.push(img);
        }
      });
    });

    if (!pending.length) {
      callback();
      return;
    }

    var remaining = pending.length;
    var settled = false;
    var timeout = window.setTimeout(finish, 1200);

    function finish() {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      callback();
    }

    function done() {
      remaining -= 1;
      if (remaining <= 0) finish();
    }

    pending.forEach(function (img) {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  function markReady() {
    section.classList.remove('is-loading');
    section.classList.add('is-ready');
    ready = true;
  }

  function applyMarquee() {
    if (prefersReducedMotion) {
      track.classList.remove('fabpad-marketplace__track--marquee');
      section.classList.add('is-static');
      markReady();
      return;
    }

    track.classList.remove('fabpad-marketplace__track--marquee');
    void track.offsetWidth;
    track.classList.add('fabpad-marketplace__track--marquee');
    markReady();
  }

  function setup(force) {
    if (settingUp) return;
    if (ready && !force) return;

    settingUp = true;
    originals = originalsList();

    if (!originals.length) {
      settingUp = false;
      markReady();
      return;
    }

    waitForImages(function () {
      requestAnimationFrame(function () {
        cloneLogos();
        lastViewportWidth = Math.round(viewport.getBoundingClientRect().width);
        applyMarquee();
        settingUp = false;
      });
    });
  }

  function onViewportResize() {
    var width = Math.round(viewport.getBoundingClientRect().width);
    if (Math.abs(width - lastViewportWidth) < 2) return;
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      setup(true);
    }, 180);
  }

  section.addEventListener('mouseenter', function () {
    section.classList.add('is-paused');
  });

  section.addEventListener('mouseleave', function () {
    section.classList.remove('is-paused');
  });

  if (typeof ResizeObserver !== 'undefined') {
    var resizeObserver = new ResizeObserver(onViewportResize);
    resizeObserver.observe(viewport);
  } else {
    window.addEventListener('resize', onViewportResize, { passive: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) setup(true);
  });

  setup();
})();
